import { useSelector } from 'react-redux'
import { Alert, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import ConfirmFormFooter from '../../Components/antd/Forms/ConfirmFormFooter'

const CONFIRM_TITLE = 'activation_redirect_account.confirm.title'

const ActivationPendingModal = ({ visible = false, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  return (
    <Modal
      title={t('activation_redirect_account.title')}
      visible={visible}
      centered
      footer={(
        <ConfirmFormFooter
          confirmTitle={t(CONFIRM_TITLE)}
          cancelTitle={t('activation_redirect_account.cancel.title')}
          confirmClassName='logo-colored-button blue-ghost blue-hover'
          cancelClassName='logo-colored-button gray-ghost gray-hover'
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      )}
      onCancel={onCancel}
    >
      <Alert
        description={t('activation_redirect_account.account_explanation')}
        type='warning'
        showIcon
        icon={<FontAwesomeIcon icon={faTriangleExclamation} />}
      />
      <br />
      <span>{t('activation_redirect_account.email_explanation', { buttonTitle: t(CONFIRM_TITLE) })}</span>
    </Modal>
  )
}

export default ActivationPendingModal
